import React, { ReactText } from "react";
import { Chart } from "react-google-charts";

interface GeoChartProps {
  data: ReactText[][];
  width?: number;
}

function GeoChart({ data, width = 600 }: GeoChartProps) {
  return (
    <Chart
      width={width}
      chartType="GeoChart"
      options={{ colors: ["#ECCA00", "#EC0000"] }}
      data={data}
      mapsApiKey="AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBW"
      rootProps={{ "data-testid": "1" }}
    />
  );
}

export default GeoChart;
